import type { HTMLAttributes, ReactNode } from "react";

export type FieldVariant = "default" | "checkbox";

export interface FieldProps extends HTMLAttributes<HTMLDivElement> {
  label: ReactNode;
  htmlFor?: string;
  description?: ReactNode;
  error?: ReactNode;
  required?: boolean;
  variant?: FieldVariant;
  children: ReactNode;
}

export function Field({
  label,
  htmlFor,
  description,
  error,
  required,
  variant = "default",
  className,
  children,
  ...rest
}: FieldProps) {
  const classes = ["qr-field"];
  if (variant !== "default") classes.push(`qr-field-${variant}`);
  if (className) classes.push(className);

  return (
    <div
      className={classes.join(" ")}
      data-invalid={error ? "true" : undefined}
      {...rest}
    >
      <label className="qr-field-label" htmlFor={htmlFor}>
        {label}
        {required ? (
          <span className="qr-field-required" aria-hidden="true">
            {" "}
            *
          </span>
        ) : null}
      </label>
      {description ? (
        <p className="qr-field-description">{description}</p>
      ) : null}
      {children}
      {error ? (
        <p className="qr-field-error" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
